import { Component, Input } from '@angular/core';
import { ProprieteModele } from '../../../modeles/proprieteModel';

@Component({
  selector: 'app-frais-propriete',
  templateUrl: './frais-propriete.component.html',
  styleUrls: ['./frais-propriete.component.scss'],
  standalone: false
})
export class FraisProprieteComponent {
  @Input()
  propriete: ProprieteModele;
}
